module.exports = __webpack_public_path__ + "img/Peacecle_EN.64006cb2.png";